import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-social-share',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './social-share.component.html',
  styleUrls: ['./social-share.component.scss']
})
export class SocialShareComponent {
  @Input() url: string = "";
  facebookShareUrl: string = "https://www.facebook.com/sharer/sharer.php?u=";
  twitterShareUrl: string = "https://twitter.com/intent/tweet?url=";
  linkedinShareUrl: string = "https://www.linkedin.com/sharing/share-offsite/?url=";
  whatsappShareUrl = "https://api.whatsapp.com/send?text=";

  ngOnInit(): void {
    this.url = `${window.location.origin}${this.url}`
    this.facebookShareUrl = `${this.facebookShareUrl}${encodeURIComponent(this.url)}`;
    this.twitterShareUrl = `${this.twitterShareUrl}${encodeURIComponent(this.url)}`;
    this.linkedinShareUrl = `${this.linkedinShareUrl}${encodeURIComponent(this.url)}`;
    this.whatsappShareUrl = `${this.whatsappShareUrl}${encodeURIComponent(this.url)}`;
  }

}
